import Logger from './logger';

const log = new Logger();

/**
 * getParamByName:
 * Returns a given URL parameter
 *
 * @param name
 * @param url
 * @returns {*}
 */
export default (name, url = false) => {
  log.debug({
    category: 'helpers',
    message: 'getParamByName',
    data: {
      name,
      url
    }
  });

  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[[\]]/g, '\\$&');

  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
